import { TRACKING_METHOD_TYPE } from 'types/tracking'
import * as yup from 'yup'
import {
  bookingPermissionTestOptions,
  MotorCarrierUserForCurrentUserSchema,
} from 'apps/fleet-planner/hooks/useCarrierMembershipApi/schema/MotorCarrierUserForCurrentUserSchema'

export const SCHEMA_MESSAGES = {
  CARRIER_SIGNATURE_REQUIRED: 'Please enter your full name',
  DISPATCHER_ID_REQUIRED: 'Please select a dispatcher',
  DRIVER_ID_REQUIRED: 'Please select a driver',
  MOTOR_CARRIER_USER_REQUIRED: 'Please select a carrier',
  TRACKING_METHOD_REQUIRED: 'Please select a tracking method',
  VIN_LENGTH: 'Must be between 4 and 6 digits',
}

export const RateConfirmationFormSchema = yup.object({
  /**
   * @example 'Steven Grant Rogers'
   */
  carrierSignature: yup.string().trim().required(SCHEMA_MESSAGES.CARRIER_SIGNATURE_REQUIRED),

  /**
   * @description The Transfix `ParentUser.id` of the dispatcher.
   * @example '123'
   */
  dispatcherId: yup.string().required(SCHEMA_MESSAGES.DISPATCHER_ID_REQUIRED),
  /**
   * @description The Transfix `ParentUser.id` of the driver.
   * @example '123'
   */
  driverId: yup.string().when('driverRequired', {
    is: true,
    then: yup.string().required(SCHEMA_MESSAGES.DRIVER_ID_REQUIRED),
    otherwise: yup.string().notRequired().nullable(),
  }),
  /**
   * @example true
   */
  driverRequired: yup.boolean().required(),
  /**
   * @example { id: '123', type: 'dispatcher', motorCarrier: { id: '123', name: 'Trucker Inc.', dotNumber: 1234567, mcNumber: 7654321 } }
   */
  motorCarrierUser: MotorCarrierUserForCurrentUserSchema.required(
    SCHEMA_MESSAGES.MOTOR_CARRIER_USER_REQUIRED
  ).test(bookingPermissionTestOptions),
  /**
   * @example 'keep_truckin'
   */
  trackingMethod: yup
    .mixed<TRACKING_METHOD_TYPE>()
    .oneOf(Object.values(TRACKING_METHOD_TYPE))
    .required(SCHEMA_MESSAGES.TRACKING_METHOD_REQUIRED),
  /**
   * @example 'E2305'
   */
  trailerNumber: yup.string().notRequired().nullable(),
  /**
   * @example '105Y
   */
  truckNumber: yup.string().notRequired().nullable(),

  /**
   * @description Last 4-6 digits of tractor VIN
   * @example 283641
   */
  vin: yup
    .string()
    .trim()
    .min(4, SCHEMA_MESSAGES.VIN_LENGTH)
    .max(6, SCHEMA_MESSAGES.VIN_LENGTH)
    .notRequired()
    .nullable(),
})

export type TRateConfirmationFormSchema = yup.InferType<typeof RateConfirmationFormSchema>
